(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a1-mini-launch-home"] && !Shopify.designMode) return;
  try {
    
  const a1Sections = document.querySelectorAll('[data-a1-home-launch]');
  const a1Hero = document.querySelector('.a1-home-launch--hero');

  const a1HomeQaMode = new URLSearchParams(window.location.search).get('_a1_analytics_qa') === '1';
  const a1HomeTrack = (eventName, properties = {}) => {
    const record = { event: eventName, ...properties };
    window.__TYVOK_A1_EVENTS__ = window.__TYVOK_A1_EVENTS__ || [];
    window.__TYVOK_A1_EVENTS__.push(record);
    if (a1HomeQaMode) return;
    if (typeof window.gtag === 'function') window.gtag('event', eventName, properties);
    else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(record);
    }
  };

  const a1HomeCtaLocation = (link) => {
    if (link.matches('.a1-launch-nav-item a')) return 'home_navigation';
    if (link.matches('.a1-home-launch__banner')) return 'home_hero_banner';
    if (link.matches('.a1-home-launch__secondary')) return 'home_hero_purchase';
    if (link.matches('.a1-home-launch__mobile-sticky')) return 'home_mobile_sticky';
    if (link.matches('.a1-home-launch__reward')) return 'home_reward_card';
    if (link.matches('.a1-home-launch__primary')) return 'home_primary';
    return 'home_other';
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.a1-home-launch a[href], .a1-launch-nav-item a[href]');
    if (!link) return;
    const section = link.closest('[data-a1-home-launch]');
    const rewardPower = link.querySelector('.a1-home-launch__power')?.textContent.trim() || '';
    const destination = new URL(link.href, window.location.origin);
    a1HomeTrack('a1_home_cta_click', {
      cta_location: a1HomeCtaLocation(link),
      cta_text: (link.getAttribute('aria-label') || link.textContent || '').trim().slice(0, 100),
      reward_power: rewardPower,
      destination_path: destination.pathname,
      section_layout: section?.classList.contains('a1-home-launch--hero') ? 'hero' : 'compact',
    });
  });

  const a1CampaignUrl = (content) => {
    const primary = a1Hero?.querySelector('.a1-home-launch__primary');
    if (!primary) return '';
    const url = new URL(primary.href, window.location.origin);
    url.hash = '';
    url.searchParams.set('utm_source', 'tyvok');
    url.searchParams.set('utm_medium', 'homepage');
    url.searchParams.set('utm_campaign', 'a1mini_launch');
    url.searchParams.set('utm_content', content);
    return url.toString();
  };

  const addA1NavItem = (list, mobile) => {
    if (!list || list.querySelector('.a1-launch-nav-item')) return;
    const href = a1CampaignUrl('home_nav');
    if (!href) return;
    const item = document.createElement('li');
    item.className = 'a1-launch-nav-item';
    if (!mobile) item.setAttribute('role', 'none');
    const link = document.createElement('a');
    link.href = href;
    link.textContent = 'A1 Mini $99';
    if (!mobile) link.setAttribute('role', 'menuitem');
    const badge = document.createElement('span');
    badge.className = 'a1-launch-nav-badge';
    badge.textContent = 'HOT';
    link.appendChild(badge);
    item.appendChild(link);
    list.prepend(item);
  };

  const rewriteA1HomepageLinks = () => {
    const href = a1CampaignUrl('home_catalog_entry');
    if (!href) return;
    document.querySelectorAll('a[href*="/products/a1mini-desktop-laser-engraving-machine"]').forEach((link) => {
      link.href = href;
    });
  };

  const initializeA1Homepage = () => {
    addA1NavItem(document.querySelector('.thb-full-menu'), false);
    addA1NavItem(document.querySelector('#mobile-menu .mobile-menu'), true);
    rewriteA1HomepageLinks();
  };

  initializeA1Homepage();
  window.addEventListener('load', initializeA1Homepage, { once: true });

  const a1MobileCta = a1Hero?.querySelector('[data-a1-mobile-cta]');
  const a1HeroVisual = a1Hero?.querySelector('.a1-home-launch__hero');
  if (a1MobileCta && a1HeroVisual && 'IntersectionObserver' in window) {
    const a1HeroObserver = new IntersectionObserver((entries) => {
      a1MobileCta.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0.08 });
    a1HeroObserver.observe(a1HeroVisual);
  }

  a1Sections.forEach((section) => {
    const output = section.querySelector('[data-a1-countdown]');
    if (!section.dataset.deadline) return;
    const update = () => {
      const remaining = new Date(section.dataset.deadline).getTime() - Date.now();
      if (remaining <= 0) {
        section.hidden = true;
        document.querySelectorAll('.a1-launch-nav-item').forEach((item) => item.remove());
        return;
      }
      if (!output) return;
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      output.textContent = `${days}d ${hours}h remaining`;
    };
    update();
    window.setInterval(update, 60000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a1-mini-pledge-flow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-a1-pledge]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const panels = [...root.querySelectorAll('[data-step-panel]')];
    const stepButtons = [...root.querySelectorAll('[data-step-button]')];
    const rewards = [...root.querySelectorAll('[data-reward]')];
    const addons = [...root.querySelectorAll('[data-addon]')];
    const nextToAddons = root.querySelector('[data-next-step="2"]');
    const checkoutButton = root.querySelector('[data-checkout]');
    const checkoutError = root.querySelector('[data-checkout-error]');
    const currency = root.dataset.currency || 'USD';

    const pledgeQaMode = new URLSearchParams(window.location.search).get('_a1_analytics_qa') === '1';
    const pledgeTrack = (eventName, properties = {}) => {
      const record = { event: eventName, ...properties };
      window.__TYVOK_A1_EVENTS__ = window.__TYVOK_A1_EVENTS__ || [];
      window.__TYVOK_A1_EVENTS__.push(record);
      if (pledgeQaMode) return;
      if (typeof window.gtag === 'function') window.gtag('event', eventName, properties);
      else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(record);
      }
    };
    let pledgeCurrentStep = 1;
    const pledgeRewardProperties = (input = selectedReward()) => input ? {
      reward_variant_id: input.value,
      reward_name: input.dataset.title || '',
      reward_quantity: rewardQuantity(input),
    } : {};

    const clampQuantity = (input) => {
      const value = Math.max(1, Math.min(10, Number(input?.value) || 1));
      if (input) input.value = String(value);
      return value;
    };

    const enhanceQuantity = (input) => {
      if (!input || input.parentElement?.classList.contains('ty-a1-stepper')) return;
      input.inputMode = 'numeric';

      const stepper = document.createElement('span');
      stepper.className = 'ty-a1-stepper';
      const decrease = document.createElement('button');
      const increase = document.createElement('button');
      const inputLabel = input.getAttribute('aria-label') || 'quantity';

      decrease.type = 'button';
      decrease.textContent = '−';
      decrease.setAttribute('aria-label', `Decrease ${inputLabel}`);
      increase.type = 'button';
      increase.textContent = '+';
      increase.setAttribute('aria-label', `Increase ${inputLabel}`);

      input.parentNode.insertBefore(stepper, input);
      stepper.append(decrease, input, increase);

      const limits = () => ({
        min: Math.max(0, Number(input.min || 0)),
        max: Math.max(1, Number(input.max || 10)),
      });
      const syncDisabled = () => {
        const { min, max } = limits();
        const value = Number(input.value) || 0;
        decrease.disabled = input.disabled || value <= min;
        increase.disabled = input.disabled || value >= max;
      };
      const changeQuantity = (delta) => {
        if (input.disabled) return;
        const { min, max } = limits();
        const current = Number(input.value) || min;
        input.value = String(Math.max(min, Math.min(max, current + delta)));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        syncDisabled();
      };

      decrease.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        changeQuantity(-1);
      });
      increase.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        changeQuantity(1);
      });
      input.addEventListener('input', syncDisabled);
      input.addEventListener('change', syncDisabled);
      new MutationObserver(syncDisabled).observe(input, {
        attributes: true,
        attributeFilter: ['disabled', 'min', 'max'],
      });
      syncDisabled();
    };

    root.querySelectorAll('[data-reward-quantity], [data-addon-quantity]').forEach(enhanceQuantity);

    const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
    }).format(Number(cents || 0) / 100);

    const rewardQuantity = (input) => clampQuantity(input.closest('[data-reward-card]')?.querySelector('[data-reward-quantity]'));
    const addonQuantity = (input) => clampQuantity(input.closest('.ty-a1-addon')?.querySelector('[data-addon-quantity]'));
    const selectedReward = () => rewards.find((input) => input.checked);
    const selectedAddons = () => addons.filter((input) => input.checked);

    const selections = () => {
      const reward = selectedReward();
      return [
        ...(reward ? [{ input: reward, quantity: rewardQuantity(reward) }] : []),
        ...selectedAddons().map((input) => ({ input, quantity: addonQuantity(input) })),
      ];
    };

    const updateSummary = () => {
      const items = selections();
      const lines = root.querySelector('[data-summary-lines]');
      const empty = root.querySelector('[data-summary-empty]');
      lines.replaceChildren();
      empty.hidden = items.length > 0;
      let total = 0;
      let regularValue = 0;

      items.forEach(({ input, quantity }) => {
        const price = Number(input.dataset.price || 0);
        const compareAt = Math.max(price, Number(input.dataset.compareAt || price));
        total += price * quantity;
        regularValue += compareAt * quantity;
        const line = document.createElement('div');
        line.className = 'ty-a1-summary__line';
        const image = document.createElement('img');
        image.src = input.dataset.image || '';
        image.alt = '';
        const name = document.createElement('span');
        name.textContent = `${input.dataset.title}${quantity > 1 ? ` × ${quantity}` : ''}`;
        const amount = document.createElement('b');
        amount.textContent = formatMoney(price * quantity);
        line.append(image, name, amount);
        lines.append(line);
      });

      const savings = Math.max(0, regularValue - total);
      const savingsRow = root.querySelector('[data-summary-savings]');
      savingsRow.hidden = savings <= 0;
      root.querySelector('[data-summary-savings-value]').textContent = formatMoney(savings);
      root.querySelector('[data-summary-total]').textContent = formatMoney(total);
      root.querySelector('[data-summary-status]').textContent = selectedReward()
        ? 'Ready to continue to checkout.'
        : 'Select a reward to continue.';
      nextToAddons.disabled = !selectedReward();
    };

    const setStep = (step) => {
      if (step > 1 && !selectedReward()) return;
      panels.forEach((panel, index) => {
        const active = index + 1 === step;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) panel.querySelector('h2')?.focus({ preventScroll: true });
      });
      stepButtons.forEach((button, index) => {
        const active = index + 1 === step;
        button.classList.toggle('is-active', active);
        button.toggleAttribute('aria-current', active);
        button.setAttribute('aria-disabled', index + 1 > 1 && !selectedReward() ? 'true' : 'false');
      });
      if (step === 2 && pledgeCurrentStep !== 2) {
        pledgeTrack('a1_addons_viewed', pledgeRewardProperties());
      }
      pledgeCurrentStep = step;
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    rewards.forEach((input) => {
      input.addEventListener('change', () => {
        root.querySelectorAll('[data-reward-card]').forEach((card) => {
          const selected = Boolean(card.querySelector('[data-reward]')?.checked);
          const quantity = card.querySelector('[data-reward-quantity]');
          card.classList.toggle('is-selected', selected);
          if (quantity) {
            quantity.disabled = false;
            quantity.min = '0';
            quantity.value = selected ? String(Math.max(1, Number(quantity.value) || 1)) : '0';
          }
        });
        updateSummary();
        if (input.checked) {
          pledgeTrack('a1_reward_selected', {
            selection_source: 'chooser',
            ...pledgeRewardProperties(input),
            quantity: rewardQuantity(input),
            value: (Number(input.dataset.price || 0) * rewardQuantity(input)) / 100,
            currency,
          });
        }
      });
      const quantity = input.closest('[data-reward-card]')?.querySelector('[data-reward-quantity]');
      quantity?.addEventListener('input', () => {
        const value = Math.max(0, Math.min(10, Number(quantity.value) || 0));
        quantity.value = String(value);
        if (value > 0 && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (value === 0 && input.checked) {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          updateSummary();
        }
      });
    });

    root.querySelectorAll('.ty-a1-reward__select').forEach((action) => {
      const chooseReward = () => {
        const card = action.closest('[data-reward-card]');
        const input = card?.querySelector('[data-reward]');
        const quantity = card?.querySelector('[data-reward-quantity]');
        if (!input || input.disabled) return;
        if (quantity && Number(quantity.value) < 1) quantity.value = '1';
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          updateSummary();
        }
        setStep(2);
      };
      action.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        chooseReward();
      });
      action.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();
        chooseReward();
      });
    });

    addons.forEach((input) => {
      const card = input.closest('.ty-a1-addon');
      const quantity = card?.querySelector('[data-addon-quantity]');
      input.addEventListener('change', () => {
        card?.classList.toggle('is-selected', input.checked);
        if (quantity) {
          quantity.disabled = false;
          quantity.min = '0';
          quantity.value = input.checked ? String(Math.max(1, Number(quantity.value) || 1)) : '0';
        }
        updateSummary();
        pledgeTrack('a1_addon_changed', {
          addon_variant_id: input.value,
          addon_name: input.dataset.title || '',
          selected: input.checked,
          quantity: input.checked ? addonQuantity(input) : 0,
          value: input.checked ? (Number(input.dataset.price || 0) * addonQuantity(input)) / 100 : 0,
          currency,
        });
      });
      quantity?.addEventListener('input', () => {
        const value = Math.max(0, Math.min(10, Number(quantity.value) || 0));
        quantity.value = String(value);
        if (value > 0 && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (value === 0 && input.checked) {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          updateSummary();
        }
      });
    });

    root.querySelectorAll('[data-reward-quantity], [data-addon-quantity]').forEach((input) => {
      input.addEventListener('click', (event) => event.stopPropagation());
    });

    root.querySelectorAll('[data-next-step]').forEach((button) => {
      button.addEventListener('click', () => setStep(Number(button.dataset.nextStep)));
    });
    stepButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.getAttribute('aria-disabled') !== 'true') setStep(Number(button.dataset.stepButton));
      });
    });

    const requestParams = new URLSearchParams(window.location.search);
    const requestedReward = requestParams.get('reward');
    const requestedQuantity = Math.max(1, Math.min(10, Number(requestParams.get('qty')) || 1));
    const requestedInput = rewards.find((input) => input.value === requestedReward);
    if (requestedInput && !requestedInput.disabled) {
      requestedInput.checked = true;
      requestedInput.closest('[data-reward-card]')?.classList.add('is-selected');
      const quantityInput = requestedInput.closest('[data-reward-card]')?.querySelector('[data-reward-quantity]');
      if (quantityInput) {
        quantityInput.disabled = false;
        quantityInput.min = '0';
        quantityInput.value = String(requestedQuantity);
      }
    }
    updateSummary();
    pledgeTrack('a1_chooser_view', {
      initial_step: requestParams.get('step') === 'addons' ? 'addons' : 'rewards',
      prefilled_reward: requestedInput?.value || '',
      page_path: window.location.pathname,
    });
    if (requestParams.get('step') === 'addons' && requestedInput && !requestedInput.disabled) {
      setStep(2);
    }

    const revealRequestedRewards = () => {
      const target = root.querySelector('#a1-rewards');
      if (window.location.hash !== '#a1-rewards' || !target) return;
      target.scrollIntoView({ block: 'start' });
    };
    if (document.readyState === 'complete') {
      revealRequestedRewards();
    } else {
      window.addEventListener('load', revealRequestedRewards, { once: true });
    }
    window.setTimeout(revealRequestedRewards, 180);

    checkoutButton?.addEventListener('click', async () => {
      if (!selectedReward()) {
        setStep(1);
        return;
      }
      const checkoutItems = selections();
      const checkoutValue = checkoutItems.reduce((sum, item) => sum + (Number(item.input.dataset.price || 0) * item.quantity), 0);
      pledgeTrack('a1_checkout_clicked', {
        ...pledgeRewardProperties(),
        addon_count: selectedAddons().length,
        item_quantity: checkoutItems.reduce((sum, item) => sum + item.quantity, 0),
        value: checkoutValue / 100,
        currency,
      });
      checkoutButton.disabled = true;
      checkoutButton.textContent = 'Preparing checkout…';
      checkoutError.hidden = true;
      try {
        const items = selections().map(({ input, quantity }) => ({
          id: input.value,
          quantity,
          properties: { '_Campaign': 'TYVOK A1 Mini launch' },
        }));
        const response = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) throw new Error('The selected items could not be added to the cart.');
        window.location.assign('/checkout');
      } catch (error) {
        pledgeTrack('a1_checkout_error', { error_stage: 'cart_add' });
        checkoutError.textContent = error.message || 'Checkout could not be prepared. Please try again.';
        checkoutError.hidden = false;
        checkoutButton.disabled = false;
        checkoutButton.textContent = 'Continue to checkout';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-workshop-page"] && !Shopify.designMode) return;
  try {
    
  const campaignSections = document.querySelectorAll('.campaign-workshop');

  const campaignA1QaMode = new URLSearchParams(window.location.search).get('_a1_analytics_qa') === '1';
  const campaignA1Track = (eventName, properties = {}) => {
    const record = { event: eventName, ...properties };
    window.__TYVOK_A1_EVENTS__ = window.__TYVOK_A1_EVENTS__ || [];
    window.__TYVOK_A1_EVENTS__.push(record);
    if (campaignA1QaMode) return;
    if (typeof window.gtag === 'function') window.gtag('event', eventName, properties);
    else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(record);
    }
  };
  const campaignIsA1 = window.location.pathname.includes('/pages/tyvok-a1-mini-compact-precise-safe-desktop-laser-engraver');
  if (campaignIsA1 && !window.__TYVOK_A1_CAMPAIGN_VIEWED__) {
    window.__TYVOK_A1_CAMPAIGN_VIEWED__ = true;
    campaignA1Track('a1_campaign_view', {
      campaign_name: 'a1mini_launch',
      page_path: window.location.pathname,
    });
  }

  document.addEventListener('click', (event) => {
    if (!campaignIsA1) return;
    const link = event.target.closest('a[href*="/pages/tyvok-a1-mini-choose-reward"]');
    if (link) {
      const destination = new URL(link.href, window.location.origin);
      const ctaLocation = link.matches('.ks-campaign-hero__cta')
        ? 'campaign_hero'
        : link.closest('[data-mobile-pledge]') ? 'campaign_mobile_sticky' : 'campaign_story';
      campaignA1Track('a1_campaign_cta_click', {
        cta_location: ctaLocation,
        cta_text: (link.textContent || '').trim().slice(0, 100),
        destination_path: destination.pathname,
      });
    }
    const inlineVideo = event.target.closest('[data-inline-video-src]');
    if (inlineVideo) campaignA1Track('a1_campaign_video_play', { video_type: 'creator_review' });
  });

  document.addEventListener('play', (event) => {
    if (!campaignIsA1 || !event.target.matches?.('.campaign-native-video')) return;
    if (event.target.dataset.a1PlayTracked === 'true') return;
    event.target.dataset.a1PlayTracked = 'true';
    campaignA1Track('a1_campaign_video_play', { video_type: 'official_showcase' });
  }, true);

  document.addEventListener('submit', (event) => {
    if (!campaignIsA1) return;
    const form = event.target.closest('.ks-reward-card__campaign-actions');
    if (!form) return;
    const card = form.closest('.ks-reward-card');
    const variant = form.querySelector('[name="reward"]')?.value || '';
    const quantity = Math.max(1, Math.min(10, Number(form.querySelector('[name="qty"]')?.value) || 1));
    const priceText = card?.querySelector('.ks-reward-card__price')?.textContent || '';
    const price = Number(priceText.replace(/[^0-9.]/g, '')) || 0;
    campaignA1Track('a1_reward_selected', {
      selection_source: 'campaign_reward_card',
      reward_variant_id: variant,
      reward_name: (card?.querySelector('h3')?.textContent || '').trim(),
      quantity,
      value: price * quantity,
      currency: 'USD',
    });
  });

  campaignSections.forEach((campaign) => {
    const toc = campaign.querySelector('[data-campaign-toc]');
    const allHeadings = Array.from(campaign.querySelectorAll('.campaign-workshop__story h2'));
    const headingMatchers = {
      faq: (text) => /\bfaq\b|frequently asked questions?/i.test(text),
      fulfillment: (text) => /shipping|fulfil(?:l)?ment|delivery/i.test(text),
      safety: (text) => /safety|safe operation/i.test(text)
    };

    allHeadings.forEach((heading, index) => {
      const slug = heading.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
      heading.id = `campaign-chapter-${slug || index + 1}-${index + 1}`;
    });

    Object.entries(headingMatchers).forEach(([name, matches]) => {
      const navLink = campaign.querySelector(`[data-campaign-nav-match="${name}"]`);
      const heading = allHeadings.find((candidate) => matches(candidate.textContent.trim()));
      if (!navLink || !heading) return;
      navLink.href = `#${heading.id}`;
      navLink.hidden = false;
    });

    const headings = allHeadings.slice(0, 12);
    campaign.querySelectorAll('.campaign-workshop__story img').forEach((image) => {
      image.loading = 'lazy';
      image.decoding = 'async';
    });
    const tocLinks = [];
    if (toc) {
      headings.forEach((heading, index) => {
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        if (index === 0) link.setAttribute('aria-current', 'true');
        toc.appendChild(link);
        tocLinks.push(link);
      });
    }

    if (headings.length && tocLinks.length) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (!visible.length) return;
        const activeId = visible[0].target.id;
        tocLinks.forEach((link) => {
          if (link.getAttribute('href') === `#${activeId}`) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-18% 0px -68% 0px', threshold: 0 });
      headings.forEach((heading) => observer.observe(heading));
    }

    const mobilePledge = campaign.querySelector('[data-mobile-pledge]');
    const rewards = campaign.querySelector('#available-rewards');
    if (mobilePledge && rewards && 'IntersectionObserver' in window) {
      const footer = document.querySelector('footer, [role="contentinfo"], .footer');
      const hiddenTargets = new Set();
      const rewardObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) hiddenTargets.add(entry.target);
          else hiddenTargets.delete(entry.target);
        });
        mobilePledge.classList.toggle('is-hidden', hiddenTargets.size > 0);
      }, { rootMargin: '0px 0px 120px 0px', threshold: 0 });
      rewardObserver.observe(rewards);
      if (footer) rewardObserver.observe(footer);
    }

    const progressEndpoint = campaign.dataset.campaignProgressEndpoint;
    const progress = campaign.querySelector('[data-campaign-progress]');
    if (progressEndpoint && progress) {
      const refreshProgress = async () => {
        try {
          const response = await fetch(progressEndpoint, {
            headers: { Accept: 'application/json' },
            credentials: 'omit'
          });
          if (!response.ok) return;
          const data = await response.json();
          const units = Math.max(0, Number(data.units) || 0);
          const goal = Math.max(1, Number(data.goal) || 20);
          const percent = Math.max(0, Math.min(100, Number(data.percent) || 0));
          progress.querySelectorAll('[data-progress-units]').forEach((output) => { output.textContent = units; });
          progress.querySelectorAll('[data-progress-goal]').forEach((output) => { output.textContent = goal; });
          progress.querySelectorAll('[data-progress-percent]').forEach((output) => { output.textContent = `${percent}%`; });
          const fill = progress.querySelector('[data-progress-fill]');
          if (fill) fill.style.setProperty('--campaign-progress', `${percent}%`);
          const bar = progress.querySelector('[data-progress-bar]');
          if (bar) {
            bar.setAttribute('aria-valuemax', String(goal));
            bar.setAttribute('aria-valuenow', String(units));
          }
          const message = progress.querySelector('[data-progress-message]');
          if (message) {
            message.textContent = data.threshold_reached
              ? 'The first fulfillment threshold has been reached'
              : `First fulfillment batch unlocks at ${goal} paid units`;
          }
        } catch {
          return;
        }
      };
      refreshProgress();
      window.setInterval(refreshProgress, 60000);
    }
  });

  document.addEventListener('click', async (event) => {
    const inlineVideo = event.target.closest('[data-inline-video-src]');
    if (inlineVideo) {
      const iframe = document.createElement('iframe');
      iframe.src = inlineVideo.dataset.inlineVideoSrc;
      iframe.title = inlineVideo.dataset.inlineVideoTitle || 'TYVOK A1 Mini video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.setAttribute('allowfullscreen', '');
      iframe.dataset.tyvokEarlyYoutubeGuarded = 'true';
      inlineVideo.replaceWith(iframe);
      iframe.focus();
      return;
    }
    const videoCover = event.target.closest('[data-campaign-video-play]');
    if (videoCover) {
      const media = videoCover.closest('[data-campaign-video-cover]');
      const panel = media?.querySelector('[data-campaign-video-panel]');
      media?.classList.add('is-playing');
      videoCover.hidden = true;
      if (panel) panel.hidden = false;
      return;
    }
    const button = event.target.closest('[data-campaign-add]');
    if (!button) return;
    const campaign = button.closest('.campaign-workshop');
    const id = button.dataset.variantId;
    const quantityInput = button.closest('.ks-reward-card')?.querySelector('[data-campaign-quantity]');
    const quantity = Math.max(1, Math.min(10, Number.parseInt(quantityInput?.value || '1', 10) || 1));
    if (!id) return;
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }] })
      });
      if (!response.ok) throw new Error('cart add failed');
      window.location.assign(campaign && campaign.dataset.campaignDiscount ? campaign.dataset.campaignDiscount : '/cart');
    } catch (error) {
      button.disabled = false;
    }
  });

  const updateCampaignCountdown = () => {
    campaignSections.forEach((campaign) => {
      if (!campaign.dataset.campaignDeadline) return;
      const outputs = campaign.querySelectorAll('.campaign-countdown-live, .campaign-summary-countdown-live');
      if (!outputs.length) return;
      const remaining = new Date(campaign.dataset.campaignDeadline).getTime() - Date.now();
      if (remaining <= 0) {
        outputs.forEach((output) => { output.textContent = 'Campaign pricing has ended'; });
        return;
      }
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      outputs.forEach((output) => {
        if (output.matches('[data-days-only-countdown]')) {
          const daysRemaining = Math.max(1, Math.floor(remaining / 86400000));
          output.textContent = `${daysRemaining} ${daysRemaining === 1 ? 'day' : 'days'}`;
          output.setAttribute('aria-label', `${daysRemaining} ${daysRemaining === 1 ? 'day' : 'days'} remaining`);
        } else {
          output.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s remaining`;
        }
      });
    });
  };

  updateCampaignCountdown();
  window.setInterval(updateCampaignCountdown, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p2-ultra-v7"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.getElementById('p2u-v7');if(!root)return;const videoUrls={"ace": "https://cdn.shopify.com/s/files/1/0666/0672/7460/t/38/assets/p2u-v7-ace.mp4?v=1790257785", "portrait": "https://cdn.shopify.com/s/files/1/0666/0672/7460/t/38/assets/p2u-v7-portrait.mp4?v=1790257815", "steel": "https://cdn.shopify.com/s/files/1/0666/0672/7460/t/38/assets/p2u-v7-steel.mp4?v=1790257900"};
const dialogs=[...root.querySelectorAll('dialog')];
function showDialog(dialog){dialog.showModal();}
function closeDialog(dialog){dialog.close()}
dialogs.forEach(dialog=>{dialog.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>closeDialog(dialog)));dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDialog(dialog)}});dialog.addEventListener('close',()=>{;if(dialog.id==='video-dialog'){player.pause();player.removeAttribute('src');player.load()}})});
const player=root.querySelector('#player');root.querySelectorAll('[data-video]').forEach(button=>button.addEventListener('click',()=>{root.querySelector('#video-title').textContent=button.dataset.title;player.src=videoUrls[button.dataset.video];showDialog(root.querySelector('#video-dialog'));player.play().catch(()=>{})}));
const projects=JSON.parse(root.querySelector('#p2u-project-data').textContent);
const tabs=[...root.querySelectorAll('[data-project]')];function selectProject(button){tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===button));t.tabIndex=t===button?0:-1});const p=projects[button.dataset.project];root.querySelector('#project-no').textContent=p.no;root.querySelector('#project-title').textContent=p.title;root.querySelector('#project-copy').textContent=p.copy;root.querySelector('#project-panel').setAttribute('aria-labelledby',button.id);root.querySelector('#project-tags').replaceChildren(...p.tags.map(text=>{const span=document.createElement('span');span.textContent=text;return span}))}tabs.forEach((button,index)=>{button.addEventListener('click',()=>selectProject(button));button.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(index+1)%tabs.length;if(e.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();selectProject(tabs[next]);tabs[next].focus()}})});
const sticky=root.querySelector('#sticky-buy');const hero=root.querySelector('.hero');const buy=root.querySelector('#buy');function updateSticky(){const h=hero.getBoundingClientRect();const b=buy.getBoundingClientRect();sticky.hidden=h.bottom>100||(b.top<innerHeight&&b.bottom>80)}window.addEventListener('scroll',updateSticky,{passive:true});window.addEventListener('resize',updateSticky);updateSticky();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvok-accessory-overview"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('product:variant-change', function (event) {
  const variant = event.detail && event.detail.variant;
  if (!variant) return;
  document.querySelectorAll('.tyvok-accessory-overview').forEach(function (section) {
    const data = section.querySelector('[data-accessory-images]');
    if (!data) return;
    const images = JSON.parse(data.textContent);
    const image = images[String(variant.id)];
    const element = section.querySelector('.tyvok-accessory-overview__image');
    if (!image || !element) return;
    element.removeAttribute('srcset');
    element.src = image.url;
    element.width = image.width;
    element.height = image.height;
    const caption = section.querySelector('[data-accessory-selected]');
    if (caption) caption.textContent = image.title;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvok-p2-conversion-v1"] && !Shopify.designMode) return;
  try {
    
(function(){
  function emit(name, params){
    var payload=Object.assign({event_category:'p2_conversion_v1',page_location:window.location.href},params||{});
    try{if(typeof window.gtag==='function')window.gtag('event',name,payload);else{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:name},payload));}}catch(error){}
  }
  function init(root){
    if(!root||root.dataset.p2Bound==='true')return;
    root.dataset.p2Bound='true';
    var form=root.querySelector('.p2-conversion__form');
    var hiddenId=root.querySelector('[data-p2-variant-id]');
    var price=root.querySelector('[data-p2-price]');
    var compare=root.querySelector('[data-p2-compare]');
    var saving=root.querySelector('[data-p2-saving]');
    var automaticDiscount=root.querySelector('[data-p2-automatic-discount]');
    var add=root.querySelector('[data-p2-add]');
    var addLabel=root.querySelector('[data-p2-add-label]');
    var buyNow=root.querySelector('[data-p2-buy-now]');
    var errorBox=root.querySelector('[data-p2-error]');
    var stickyTitle=root.querySelector('[data-p2-sticky-title]');
    var stickyPrice=root.querySelector('[data-p2-sticky-price]');
    var quantity=root.querySelector('[data-p2-quantity]');
    var soldOutText=root.dataset.soldOutLabel||'';
    var addText=root.dataset.addLabel||'';
    var formErrorText=root.dataset.formErrorLabel||'';
    root.querySelectorAll('[data-p2-thumb]').forEach(function(button){
      button.addEventListener('click',function(){
        var image=root.querySelector('[data-p2-main-image]');
        if(!image)return;
        image.style.opacity='0';
        window.setTimeout(function(){image.src=button.dataset.imageSrc;image.srcset='';image.alt=button.dataset.imageAlt||'';image.style.opacity='1';},100);
        root.querySelectorAll('[data-p2-thumb]').forEach(function(item){item.classList.remove('is-active');item.setAttribute('aria-pressed','false');});
        button.classList.add('is-active');button.setAttribute('aria-pressed','true');
      });
    });
    root.querySelectorAll('[data-p2-variant]').forEach(function(input){
      input.addEventListener('change',function(){
        if(!input.checked)return;
        root.querySelectorAll('[data-p2-variant-card]').forEach(function(card){card.classList.remove('is-selected');});
        input.closest('[data-p2-variant-card]').classList.add('is-selected');
        hiddenId.value=input.value;
        price.textContent=input.dataset.price;
        var compareCents=Number(input.dataset.compareCents||0);
        var priceCents=Number(input.dataset.priceCents||0);
        if(compareCents>priceCents){compare.textContent=input.dataset.compare;compare.classList.remove('is-hidden');saving.textContent=input.dataset.saving; saving.classList.remove('is-hidden');}else{compare.classList.add('is-hidden');saving.classList.add('is-hidden');}
        if(automaticDiscount){automaticDiscount.textContent='Includes '+input.dataset.automaticDiscountMoney+' automatic Fall Sale discount';automaticDiscount.classList.toggle('is-hidden',Number(input.dataset.automaticDiscount||0)<=0);}
        var available=input.dataset.available==='true';
        add.disabled=!available;buyNow.disabled=!available;addLabel.textContent=available?addText:soldOutText;
        if(stickyTitle)stickyTitle.textContent=input.dataset.title;
        if(stickyPrice)stickyPrice.textContent=input.dataset.price;
        var url=new URL(window.location.href);url.searchParams.set('variant',input.value);window.history.replaceState({},'',url.toString());
        emit('p2_variant_select',{variant_id:input.value,variant_title:input.dataset.title,variant_price:priceCents});
      });
    });
    root.querySelector('[data-p2-quantity-minus]').addEventListener('click',function(){quantity.value=Math.max(1,Number(quantity.value||1)-1);});
    root.querySelector('[data-p2-quantity-plus]').addEventListener('click',function(){quantity.value=Math.max(1,Number(quantity.value||1)+1);});
    form.addEventListener('submit',function(){emit('p2_add_to_cart',{variant_id:hiddenId.value,quantity:Number(quantity.value||1)});});
    buyNow.addEventListener('click',async function(){
      if(buyNow.disabled)return;
      buyNow.disabled=true;errorBox.hidden=true;
      try{
        var response=await fetch((window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        if(!response.ok)throw new Error('add_failed');
        emit('p2_buy_now',{variant_id:hiddenId.value,quantity:Number(quantity.value||1)});
        window.location.href='/checkout';
      }catch(error){errorBox.textContent=formErrorText;errorBox.hidden=false;buyNow.disabled=false;}
    });
    var stickyAdd=root.querySelector('[data-p2-sticky-add]');
    if(stickyAdd)stickyAdd.addEventListener('click',function(){if(add&&!add.disabled)add.click();});
    emit('p2_conversion_view',{variant_id:hiddenId.value});
  }
  function initAll(scope){(scope||document).querySelectorAll('.p2-conversion').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvok-x1spro-editorial"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(!document.querySelector('script[data-x1spro-schema="2026"]')) return;
  function removeArchivedFaqSchema(){
    var legacyFaq = document.querySelector('script[data-tyvok-runtime-faq="20260525"]');
    if(legacyFaq) legacyFaq.remove();
  }
  removeArchivedFaqSchema();
  new MutationObserver(removeArchivedFaqSchema).observe(document.head,{childList:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyvok-x1spro-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var button=event.target.closest('.x1sp-video-start');
  if(!button) return;
  var template=button.parentElement.querySelector('.x1sp-video-template');
  if(!template) return;
  button.replaceWith(template.content.cloneNode(true));
  template.remove();
});

  } catch(e) { console.error(e); }
})();
})();
